
import DownButton from './down-button.vue'
import UserMessage from './user-message.vue'
import AIMessage from './ai-message.vue'
import ChatError from './chat-error.vue'
import UserCancelled from './user-cancelled.vue'
import AiAssistant from './ai-assistant'

const __default__ = {
  components: {
    DownButton,
    AiAssistant,
    UserMessage,
    UserCancelled,
    AIMessage,
    ChatError
  },
  props: {
    chatId: {type: String, required: false, default: ''},
    generating: {type: Boolean, default: false},
    history: {type: Array, default: () => []},
    mode: {type: String, default: 'expanded'},
    readonly: {type: Boolean, default: false},
    refHistoryLen: {type: Number, default: undefined}
  },
  emits: ['text-added', 'ask-ai', 'like', 'dislike', 'save', 'refrag', 'onboarding-completed', 'prompt-save'],
  data() {
    return {
      show_down: false,
      answer_min_height: '0px',
    }
  },
  computed: {
    last_answer_idx() {
      return this.history.findLastIndex(x => x.type === 'assistant')
    },
  },
  watch: {
    'history.length': async function (length, previous) {
      await this.$nextTick()
      this.setClientHeight()
      if (this.generating && length > previous) {
        await this.$nextTick()
        this.scrollToEnd()
      }
    },
  },
  mounted() {
    this.$refs.scroller.getObserver()
      .observe(this.$refs.chat_end, this.setShowDown)

    this.setClientHeight()
    if (this.generating) {
      this.$nextTick(() => this.scrollToEnd())
    }
  },
  methods: {
    setShowDown({position}){
      this.show_down = position === 'below'
    },
    setClientHeight() {
      const content = this.$refs.scroller?.getContent()
      if (!content) return
      const last_prompt_idx = this.history.findLastIndex(x => x.type === 'user')
      const last_promp = this.$refs.history?.[last_prompt_idx]
      const prompt_height = last_promp?.$el.clientHeight || 0
      this.answer_min_height = Math.max(0, content.clientHeight - prompt_height) + 'px'
    },
    scrollToEnd() {
      this.$refs.scroller.scrollToEnd(true, {follow_end: false})
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0a22c84a-answer_min_height": (_ctx.answer_min_height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__